import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import { fromAnyToUglyJson } from 'utils/converters/json.util';

export const GET_DEPOSIT_CLIENTS_LIST_REQUEST = 'GET_DEPOSIT_CLIENTS_LIST_REQUEST';
export const GET_DEPOSIT_CLIENTS_LIST_SUCCESS = 'GET_DEPOSIT_CLIENTS_LIST_SUCCESS';
export const GET_DEPOSIT_CLIENTS_LIST_FAILURE = 'GET_DEPOSIT_CLIENTS_LIST_FAILURE';
export const GET_CLIENT_DEPOSIT_DETAILS_REQUEST = 'GET_CLIENT_DEPOSIT_DETAILS_REQUEST';
export const GET_CLIENT_DEPOSIT_DETAILS_SUCCESS = 'GET_CLIENT_DEPOSIT_DETAILS_SUCCESS';
export const GET_CLIENT_DEPOSIT_DETAILS_FAILURE = 'GET_CLIENT_DEPOSIT_DETAILS_FAILURE';
export const CREATE_REFUND_REQUEST = 'CREATE_REFUND_REQUEST';
export const CREATE_REFUND_SUCCESS = 'CREATE_REFUND_SUCCESS';
export const CREATE_REFUND_FAILURE = 'CREATE_REFUND_FAILURE';
export const EMAIL_REFUND_RECEIPT_REQUEST = 'EMAIL_REFUND_RECEIPT_REQUEST';
export const EMAIL_REFUND_RECEIPT_SUCCESS = 'EMAIL_REFUND_RECEIPT_SUCCESS';
export const EMAIL_REFUND_RECEIPT_FAILURE = 'EMAIL_REFUND_RECEIPT_FAILURE';

export const DEPOSIT_REFUND_CLIENT_REQUEST = 'DEPOSIT_REFUND_CLIENT_REQUEST';
export const DEPOSIT_REFUND_CLIENT_SUCCESS = 'DEPOSIT_REFUND_CLIENT_SUCCESS';
export const DEPOSIT_REFUND_CLIENT_FAILURE = 'DEPOSIT_REFUND_CLIENT_FAILURE';
export const CLEAR_DEPOSIT_REFUNDED = 'CLEAR_DEPOSIT_REFUNDED';

export const fetchDepositClientsList = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.transactionApiRoot,
    endpoint: `deposit/${salonId}/clients/`,
    authenticated: true,
    types: [GET_DEPOSIT_CLIENTS_LIST_REQUEST, GET_DEPOSIT_CLIENTS_LIST_SUCCESS, GET_DEPOSIT_CLIENTS_LIST_FAILURE],
  },
});

export const fetchClientDepositDetails = (salonId, clientId, appointmentId) => ({
  [AUTH_API]: {
    api_root: CONF.transactionApiRoot,
    endpoint: appointmentId ? `deposit/${salonId}/client/${clientId}/?appointment_ids=${appointmentId}` : `deposit/${salonId}/client/${clientId}/`,
    authenticated: true,
    types: [GET_CLIENT_DEPOSIT_DETAILS_REQUEST, GET_CLIENT_DEPOSIT_DETAILS_SUCCESS, GET_CLIENT_DEPOSIT_DETAILS_FAILURE],
  },
});

const createRefund = (salonId, clientId, amountToRefund, source) => ({
  ATAG: createRefund.name,
  [AUTH_API]: {
    api_root: CONF.transactionApiRoot,
    endpoint: `deposit/${salonId}/create/`,
    authenticated: true,
    types: [CREATE_REFUND_REQUEST, CREATE_REFUND_SUCCESS, CREATE_REFUND_FAILURE],
    config: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: fromAnyToUglyJson({
        clientId,
        amount: amountToRefund,
        source,
        depositType: 'refunded',
        notes: 'Refunded from the settings',
      }),
    },
  },
});

export const clearDepositRefunded = () => ({ type: CLEAR_DEPOSIT_REFUNDED });

export const createRefundAndRefresh = (salonId, clientId, amountToRefund, source) => (dispatch) => {
  dispatch(createRefund(salonId, clientId, amountToRefund, source)).then(({ type }) => {
    if (type === CREATE_REFUND_SUCCESS) {
      dispatch(fetchClientDepositDetails(salonId, clientId));
    }
  });
};

export const sendRefundEmail = (to, subject, html) => ({
  [AUTH_API]: {
    api_root: CONF.transactionApiRoot,
    endpoint: 'receipt/email/0/',
    authenticated: true,
    config: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ to, subject, html, text: 'hello' }),
    },
    types: [EMAIL_REFUND_RECEIPT_REQUEST, EMAIL_REFUND_RECEIPT_SUCCESS, EMAIL_REFUND_RECEIPT_FAILURE],
  },
});

export const fetchClient = (salonId, data, method) => {
  let url = '';
  if (data.id) {
    url = `salon/${salonId}/client/${data.id}/`;
  } else {
    url = `salon/${salonId}/client/`;
  }
  if (!method || method === 'GET') {
    return {
      [AUTH_API]: {
        api_root: CONF.apiRoot,
        endpoint: url,
        authenticated: true,
        types: [DEPOSIT_REFUND_CLIENT_REQUEST, DEPOSIT_REFUND_CLIENT_SUCCESS, DEPOSIT_REFUND_CLIENT_FAILURE],
        params: { salonId, data, method: 'GET' },
        config: {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      },
    };
  }
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: url,
      authenticated: true,
      types: [DEPOSIT_REFUND_CLIENT_REQUEST, DEPOSIT_REFUND_CLIENT_SUCCESS, DEPOSIT_REFUND_CLIENT_FAILURE],
      params: { salonId, data, method },
      config: {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
    },
  };
};
